import dayjs from 'dayjs';

const ISO_DAY_LENGTH = 'YYYY-MM-DD'.length;

export function getRelativeDayDifference(dateString: string): number {
  const now = new Date();
  const date = new Date(dateString);
  return getDifferenceInDays(date, now);
}

export const getDifferenceInDays = (date1: Date, date2: Date): number => {
  return dayjs(date2).diff(dayjs(date1), 'day');
};

/**
 * The locale is read from dayjs rather than passed in, so a caller only gets the app locale where
 * `setDayjsLocale` keeps dayjs in sync with i18next. A context that never calls it formats against
 * whatever locale dayjs was left on.
 */
export function createDateFormatter(options: Intl.DateTimeFormatOptions) {
  const formatterByLocale = new Map<string, Intl.DateTimeFormat>();

  return (day: string): string => {
    const locale = dayjs.locale();
    let formatter = formatterByLocale.get(locale);

    if (!formatter) {
      formatter = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', ...options });
      formatterByLocale.set(locale, formatter);
    }

    return formatter.format(new Date(`${day.slice(0, ISO_DAY_LENGTH)}T00:00:00Z`));
  };
}
